import { useEffect } from 'react';

const useTableFixedColumnsShadow = (dataSource, loading) => {
    useEffect(() => {
        const hasFixedColumnsOnPage = document.querySelector('.ant-table-cell-fix-left, .ant-table-cell-fix-right');
        if (!hasFixedColumnsOnPage)
        {
            return;
        }

        const timeoutId = setTimeout(() => {
            const tableContainer = document.querySelector('.ant-table-tbody');

            if (!tableContainer) {
                return;
            }

            const hasFixedColumns = tableContainer.querySelector('.ant-table-cell-fix-left, .ant-table-cell-fix-right');
            if (!hasFixedColumns) {
                return;
            }

        const updateShadow = () => {
            const scrollContainer = document.querySelector('.ant-table-content') || tableContainer;
            const hasHorizontalScroll = scrollContainer.scrollWidth > scrollContainer.clientWidth;
            let leftCells = document.querySelectorAll('.ant-table-cell-fix-left');
            let rightCells = document.querySelectorAll('.ant-table-cell-fix-right');

            leftCells.forEach(cell => {
                if (hasHorizontalScroll) {
                    cell.classList.add('has-scroll');
                } else {
                    cell.classList.remove('has-scroll');
                }
            });

            rightCells.forEach(cell => {
                if (hasHorizontalScroll) {
                    cell.classList.add('has-scroll');
                } else {
                    cell.classList.remove('has-scroll');
                }
            });
        };

        updateShadow();

        const resizeObserver = new ResizeObserver(updateShadow);
        resizeObserver.observe(tableContainer);
        tableContainer.addEventListener('scroll', updateShadow);

        const handleMouseOver = (e) => {
            if (e.target.closest('tr')) {
                setTimeout(updateShadow, 10);
            }
        };

        tableContainer.addEventListener('mouseover', handleMouseOver);

        return () => {
            resizeObserver.disconnect();
            tableContainer.removeEventListener('scroll', updateShadow);
            tableContainer.removeEventListener('mouseover', handleMouseOver);
        };
        }, 100);

        return () => {
            clearTimeout(timeoutId);
        };
    }, [dataSource, loading]);
};

export default useTableFixedColumnsShadow;
